import { styled } from '@linaria/react';

const ContentWrapper = styled.div<{
  isWider?: boolean;
  isAddToCartSticky?: boolean;
}>`
  margin: 0 auto;
  padding: 0;
  width: 100%;
  margin-bottom: ${({ isAddToCartSticky }) =>
    isAddToCartSticky ? '84px' : '0'};
  max-width: ${({ isWider }) => (isWider ? '80rem' : '64.6875rem')};
  @media (min-width: 105rem) {
    max-width: ${({ isWider }) => (isWider ? '100rem' : '64.6875rem')};
  }
`;

export default ContentWrapper;
